module.exports = __webpack_public_path__ + "static/media/Dazzle.7145c9ee.png";